import Icon from '../components/Icon.vue'

Icon.register({
  guitar: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M502.6 54.6c12.5 12.5 12.5 32.8 0.1 45.2l-67.9 67.9c-12.5 12.5-32.8 12.5-45.3 0l-54.2 54.2c28.9 45.4 28.9 100.4-4.2 133.5-9.7 9.7-21.2 16.4-33.9 20.5-18.8 6.1-33.1 23.6-34.9 42.7-2.3 24.1-11.6 46.4-28.8 63.5-46.1 46.1-129.1 37.9-185.3-18.3s-64.5-139.2-18.3-185.3c17.1-17.2 39.4-26.5 63.4-28.8 19.2-1.8 36.6-16.1 42.7-34.9 4.1-12.7 10.8-24.2 20.5-33.9 33.1-33.1 88.1-33.2 133.5-4.2l54.2-54.1c-12.5-12.5-12.5-32.8 0-45.3l67.9-67.9c12.5-12.5 32.8-12.5 45.3 0zM208 352c26.5 0 48-21.5 48-48s-21.5-48-48-48-48 21.5-48 48 21.5 48 48 48z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/guitar.js
// module id = 1416
// module chunks = 0